/** @jsx isolateComponent */

import { css } from '@emotion/core';

import { isolateComponent } from '@zapier/common-utils';
import { Colors } from '@zapier/design-system';

import { Currency, PlanV2 } from '@zapier/design-system-revenue/src/types';
import { formatPriceToBeInCurrency } from '@zapier/design-system-revenue/src/utils';

type TaskLimitDropdownListItemProps = {
  /** The currency to use for pricing information. */
  currency: Currency;
  /** The `TaskLimitVariant` object to pull data from. */
  plan: PlanV2;
};

const Styles = {
  root: css`
    display: flex;
    flex-direction: column;
    font-weight: normal;
    padding: 4px 0;
  `,

  currency: css`
    color: ${Colors.blue500};
    font-weight: 700;
  `,

  muted: css`
    color: ${Colors.grey500};
  `,

  tasks: css`
    color: ${Colors.black};
    font-weight: 600;
  `,
};

/**
 * An individual item in a `TaskLimitDropdown`.
 */
export const TaskLimitDropdownListItem = ({
  currency,
  plan,
}: TaskLimitDropdownListItemProps) => {
  const formattedMonthlyPayment = formatPriceToBeInCurrency(
    plan.amount / 12,
    currency,
    true,
    {
      maxDecimals: 2,
      minDecimals: 0,
      useRelativeRounding: false,
    }
  );

  return (
    <span css={Styles.root}>
      <span css={Styles.currency}>{formattedMonthlyPayment}</span>
      <span>
        <span css={Styles.tasks}>
          {Number(plan.tasks).toLocaleString()} Tasks{' '}
        </span>
        <span css={Styles.muted}>/mo</span>
      </span>
    </span>
  );
};
